import React from "react";
import { WithStyles, withStyles, createStyles, Theme } from "@material-ui/core";

import { Settings } from "../../features/cashbox/ui";


const styles = (theme: Theme) => createStyles({
  container: {
    display: 'flex',
    margin: '0 24px',
    [theme.breakpoints.down(600)]: {
      marginInline: 0,
      paddingBottom: 16
    },
  }
});

interface Props extends WithStyles<typeof styles> {
}

function RestaurantActions({ classes }: Props) {
  return (
    <div className={classes.container}><Settings /></div>
  )
}

export default withStyles(styles)(RestaurantActions);
